/**
@prop --ux-table-bg-color: default background-color of the table
@prop --ux-table-border-color: border-color of table cells
@prop --ux-table-text-color: text-color of the table
@prop --ux-table-header-font-size: font size of the table header
@prop --ux-table-header-font-weight: font weight of the table header
@prop --ux-table-header-bg-color: background-color of the table header
@prop --ux-table-header-text-color: text-color of the table header
@prop --ux-table-header-text-transform: text-transform applied the the table header
@prop --ux-table-header-padding-vertical: vertical padding of table header
@prop --ux-table-row-bg-color-even: background-color of even rows
@prop --ux-table-row-bg-color-odd: background-color of odd rows
@prop --ux-table-row-hover-border-color: row border-color when hovered
@prop --ux-table-row-hover-text-color: row text-color when hovered
@prop --ux-table-row-selected-bg-color: background-color of selected rows
@prop --ux-table-row-selected-text-color: text-color of selected rows
@prop --ux-table-row-padding-vertical: vertical padding of table rows
@prop --ux-table-cell-min-height: min-height of table cells
@prop --ux-table-cell-padding-horizontal: horizontal padding of table cells
@prop --ux-table-cell-padding-vertical: vertical padding of table cells
@prop --ux-table-sort-active-color: color of the active sort arrow
@prop --ux-table-sort-inactive-color: color of the inactive sort arrow
@prop --ux-table-sort-inactive-opacity: opacity of the inactive sort arrow
 */
.ux-table-data {
  display: block;
  font-family: var(--ux-font);
  margin: 0;
  max-width: 100%;
  position: relative;

  &__table {
    border-collapse: collapse;
    border-spacing: 0;

    .ux-table-data--full-width & {
      min-width: 100%;
    }
  }

  &__th {
    background-color: var(--ux-table-header-bg-color);
    color: var(--ux-table-header-text-color);
    font-size: var(--ux-table-header-font-size);
    font-weight: var(--ux-table-header-font-weight);
    padding: var(--ux-table-header-padding-vertical) var(--ux-table-cell-padding-horizontal);
    text-align: start;
    text-transform: var(--ux-table-header-text-transform);
    white-space: nowrap;
  }

  &__td {
    padding: var(--ux-table-row-padding-vertical) 0;
    white-space: nowrap;

    &--multiline {
      hyphens: auto;
      overflow-wrap: break-word;
      word-wrap: break-word;
    }
  }

  &__tr {
    border-bottom: 1px solid var(--ux-table-border-color);
    border-top: 1px solid var(--ux-table-border-color);
    display: table-row;
  }

  &__tr:not(.ux-table-data__tr--selected) {
    &:nth-child(odd) td {
      background-color: var(--ux-table-row-bg-color-odd);
    }

    &:nth-child(even) td {
      background-color: var(--ux-table-row-bg-color-even);
    }
  }

  &__tr--selected td {
    background-color: var(--ux-table-row-selected-bg-color);
    color: var(--ux-table-row-selected-text-color);
  }

  &__tr:hover,
  &__tr:hover td {
    border-bottom: 1px solid var(--ux-table-row-hover-border-color);
    border-top: 1px solid var(--ux-table-row-hover-border-color);
    color: var(--ux-table-row-hover-text-color);
  }

  &__cell {
    align-items: center;
    box-sizing: border-box;
    display: flex;
    justify-content: flex-start;
    min-height: var(--ux-table-cell-min-height);
    padding: var(--ux-table-cell-padding-vertical) var(--ux-table-cell-padding-horizontal);
    position: relative;

    &--group {
      border-left: 1px solid var(--ux-table-border-color);
    }
  }

  .ux-checkbox__label {
    margin: 0;
  }

  .ux-checkbox__label::before {
    background-color: var(--ux-table-bg-color);
  }
}
